import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import { Button, spacing, Text, EmptyConnectionsImage } from '@pletly/ui';

export const EmptyTeams = ({ organisationUuid, text }: Props) => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();

	const handleCreatePress = useCallback(() => {
		navigate('NewTeam', { organisationUuid });
	}, [navigate, organisationUuid]);

	return (
		<View style={styles.root}>
			<EmptyConnectionsImage />
			<Text category="h6" style={styles.text} align="center">
				{text ?? t('teams.no-teams-yet')}
			</Text>
			<Button variant="outline" color="primary" size="small" onPress={handleCreatePress}>
				{t('common.create-new')}
			</Button>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		alignItems: 'center',
		paddingTop: spacing(3),
	},
	text: {
		marginVertical: spacing(2),
	},
});

interface Props {
	organisationUuid: string;
	text?: string;
}
